import { Toaster } from "@fieldwork/ui/components/sonner";
import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { HeadContent, Outlet, createRootRouteWithContext, useRouterState } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import Header from "@/components/header";
import { ThemeProvider } from "@/components/theme-provider";
import type { orpc } from "@/utils/orpc";

import "../index.css";

export interface RouterAppContext {
  orpc: typeof orpc;
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterAppContext>()({
  component: RootComponent,
  head: () => ({
    meta: [
      {
        title: "fieldwork",
      },
      {
        name: "description",
        content: "Your own Fieldwork server, managed from one place.",
      },
    ],
    links: [

    ],
  }),
});

/** Account pages get the top header; a server's pages bring their own sidebar, and sign-in has its own layout. */
function Shell() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  if (/^\/servers\/[0-9a-f-]{36}/.test(path) || path === "/login") return <Outlet />;
  return (
    <div className="flex min-h-svh flex-col bg-[#111111] text-[#ECEAE4]">
      <Header />
      <Outlet />
    </div>
  );
}

function RootComponent() {
  return (
    <>
      <HeadContent />
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        forcedTheme="dark"
        disableTransitionOnChange
        storageKey="vite-ui-theme"
      >
        <Shell />
        <Toaster richColors />
      </ThemeProvider>
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-left" />}
      {import.meta.env.DEV && <ReactQueryDevtools position="bottom" buttonPosition="bottom-right" />}
    </>
  );
}
